import { TChatInListSchema } from '../../types/chatList';
import { validateChatItem } from '../../utils/validateChatItem';

export const getLastTimeStamp = (chats: TChatInListSchema[]): number => chats[chats.length - 1].updatedMs as number;

export const mergeChats = (stateChats: TChatInListSchema[], actionChats: TChatInListSchema[]) => {
  const validatedActionChats = actionChats.filter(chat => validateChatItem({ chat }));

  return stateChats
    .map(stateChat => {
      const chatIndex = validatedActionChats.findIndex(actionChat => actionChat.chatId === stateChat.chatId);

      if (chatIndex < 0) {
        return stateChat;
      }

      const actionChat = validatedActionChats[chatIndex];
      validatedActionChats.splice(chatIndex, 1);

      return actionChat.updatedMs >= stateChat.updatedMs ? actionChat : stateChat;
    })
    .concat(validatedActionChats)
    .sort((a, b) => b.updatedMs - a.updatedMs);
};
